import { css } from 'styled-components';

import { Media } from '../Mixins.style';

export const Section = css`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const Wrapper = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const Content = css`
  position: relative;
  display: flex;
  width: 100%;
  height: calc(100% - 88px);

  ${Media.lg`
    height: calc(100% - 80px - 80px);
  `}
`;

export const Panel = css`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0 30px;
  background: ${(props) => props.theme.background};
  overflow: auto;
  transition: 0.2s padding;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  ${Media.lg`
    padding: 0 20px;
  `}
`;

export const PanelInner = css`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const Information = css`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 600;
  line-height: 1.2;
  cursor: default;
`;

export const Title = css`
  margin-bottom: 25px;
  font-size: 128px;
  font-weight: 700;
  line-height: 1.2;
  cursor: default;
`;

export const Subtitle = css`
  margin-bottom: 15px;
  font-size: 36px;
  font-weight: 600;
  line-height: 1.2;
  cursor: default;
`;

export const Text = css`
  margin-bottom: 50px;
  font-size: 26px;
  font-weight: 600;
  line-height: 1.2;
  cursor: default;
`;
